import * as yup from 'yup'

export const schema = yup.object().shape({
  title: yup.string().required(),
  upload: yup.object().shape({
    url: yup.string().required(),
  }),
})
